module.exports = __webpack_public_path__ + "static/media/zachary-nelson-98Elr-LIvD8-unsplash.9a75449f.jpg";